export default __webpack_public_path__ + "static/media/Treeb Me Bro.4de747b0.png";